import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import CompanyBreadcrumb from 'components/company/CompanyBreadcrumb'
import ReportsTableContainer from 'components/report/list/ReportsTableContainer'
import ReportsHeader from 'components/report/list/ReportsHeader'

export default function ReportsPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <CompanyBreadcrumb crumbs={header?.crumbs} />
          </Header>
          <ReportsHeader />
        </>
      )}
      renderContent={() => <ReportsTableContainer />}
    />
  )
}
